module.exports = __webpack_public_path__ + "img/react.22545d36.svg";